export default "__VITE_ASSET__834995d9__"